import React from 'react';
import PropTypes from 'prop-types';
import {DragLayer} from 'react-dnd';
import ItemTypes from './ItemTypes.js';
import ItemPropType from './ItemPropType.js';
import TransferableSelectItemTemplate from './TransferableSelectItemTemplate.jsx';
import styles from './TransferableSelectItem.scss';

function collect(monitor) {
  let rawItem = monitor.getItem();
  return {
    items: rawItem ? rawItem.items : null,
    dimensions: rawItem ? rawItem.dimensions : null,
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

class TransferableSelectDragLayer extends React.Component {

  renderItem = (type, item) => {
    switch(type) {
    case ItemTypes.AVAILABLE:
    case ItemTypes.SELECTED:
      return <TransferableSelectItemTemplate key={item.key} item={item} className={styles.preview}/>;
    }
  }

  getItemStyles = () => {
    let {
      currentOffset,
      dimensions
    } = this.props;

    if (!currentOffset) {
      return {display: 'none'};
    }

    const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;

    return {
      transform: transform,
      WebkitTransform: transform,
      height: dimensions.height,
      width: dimensions.width,
    };
  }

  render() {
    let {
      isDragging,
      items,
      itemType,
    } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={this.getItemStyles()}>
          {items.map(item => this.renderItem(itemType, item))}
        </div>
      </div>
    );
  }
}

TransferableSelectDragLayer.propTypes = {
  items: PropTypes.arrayOf(ItemPropType),
  dimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  itemType: PropTypes.string,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool
};

export default DragLayer(collect)(TransferableSelectDragLayer);